
import { Address, CommunityEvent } from "@/types/trip";

export interface TripApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: DashboardTrip[];
}

export interface DashboardTrip {
  id: string;
  community_event?: CommunityEvent;
  pickup_at: string;
  passenger_count?: number;
  organization_price?: number | string;
  organization_price_currency?: string;
  booking_duration?: string | number;
  to_address?: Address;
  from_address?: Address;
  claimed_by: string | null;
  status?: string;
  is_round_trip?: boolean;
  mobile_number?: string;
  extra?: {
    notes?: string;
    [key: string]: any;
  };
}

export const TRIPS_PER_PAGE = 6;
